import { Star } from '@/components/icons/Star'
import { cn } from '@/utils/tailwind'

interface StarRatingProps {
  selectedRating: number | null
  onSelectRating: (rating: number) => void
  totalStars?: number
  testIdPrefix?: string
  containerClassName?: string
  starSize?: { width: number; height: number }
}

export const StarRating = ({
  selectedRating,
  onSelectRating,
  totalStars = 5,
  testIdPrefix = 'rating',
  containerClassName,
  starSize = { width: 34, height: 32 }
}: StarRatingProps) => {
  return (
    <div className={cn('flex flex-row justify-between gap-3 px-4', containerClassName)} data-testid={`${testIdPrefix}-stars`}>
      {Array.from({ length: totalStars }).map((_, index) => {
        const selected = Boolean(selectedRating && index < selectedRating)
        return (
          <button key={index} onClick={() => onSelectRating(index + 1)} data-testid={`${testIdPrefix}-${index + 1}`}>
            <Star selected={selected} {...starSize} />
          </button>
        )
      })}
    </div>
  )
}
